import { CheckCircleOutlined } from "@ant-design/icons";
import {
  StatusDeclinedIcon,
  StatusPendingIcon,
  StatusSignedIcon,
} from "@/shared/assets/svg/icons";
import statusPendingGsnIcon from "@/shared/assets/svg/icons/status-pending-gsn-icon.png";
import { IStatus } from "../types/status-map.type";

export const getStatusWithIcon = (statusId: string): IStatus => {
  const statusMap: { [key: string]: IStatus } = {
    NEW: {
      id: "NEW",
      status: "Новый",
      icon: <CheckCircleOutlined style={{ opacity: 0, marginRight: 1 }} />,
    },
    AWAITING_SIGNATURE: {
      id: "AWAITING_SIGNATURE",
      status: "Ожидает подписания",
      icon: <StatusPendingIcon />,
    },
    REJECTED: {
      id: "REJECTED",
      status: "Отклонено",
      icon: <StatusDeclinedIcon />,
    },
    SIGNED: {
      id: "SIGNED",
      status: "Подписано",
      icon: <StatusSignedIcon />,
    },
    SENT_TO_GSN: {
      id: "SENT_TO_GSN",
      status: "Отправлено в ГСН",
      icon: (
        <img
          src={statusPendingGsnIcon}
          alt="status-pending-gsn"
          width={16}
          height={16}
        />
      ),
    },
  };
  return statusMap[statusId] || statusMap.NEW;
};

